import { WhiteLabel } from "@/core/services/api/interfaces/common/WhiteLabel";
import config from "@/core/config/LayoutConfig";
import store from "@/store";
import { Mutations } from "@/store/enums/StoreEnums";

export abstract class ThemeService {
  protected static $favicon = `${process.env.BASE_URL}favicon/${process.env.VUE_APP_THEME}/favicon.ico`;

  public static instantiate(whiteLabel: WhiteLabel): void {
    console.log("instantiating theme service");
    ThemeService._setBackgroundMain(whiteLabel.background_url);
    ThemeService._setSiteName(whiteLabel.name);
    ThemeService._setSiteFavicon(whiteLabel.favicon_url);
    ThemeService._setSiteLogo(whiteLabel.logo_url, whiteLabel.dark_logo_url);
    ThemeService._setSupportEmail(whiteLabel.support_email);
    ThemeService._setSiteColors(
      whiteLabel.primary_color,
      whiteLabel.secondary_color
    );

    store.commit(Mutations.THEME_LAYOUT_CONFIG_SET, config);
  }

  protected static _setSiteColors(
    primary_color: null | string,
    secondary_color: null | string
  ): void {
    if (!primary_color || !secondary_color) {
      return;
    }
    if (document.getElementById("theme-colors")) {
      return;
    }
    const style = document.createElement("style");
    style.setAttribute("rel", "stylesheet");
    style.setAttribute("type", "text/css");
    style.setAttribute("id", "theme-colors");
    style.innerHTML = `
      :root {
        --bs-primary: ${primary_color || "#0d6efd"};
        --bs-secondary: ${secondary_color || "#6c757d"};
      } 
      .text-primary {
        color: var(--bs-primary) !important;
      }
      .bg-primary {
        background-color: var(--bs-primary) !important;
      }
      .text-secondary {
        color: var(--bs-secondary) !important;
      }
      .bg-secondary {
        background-color: var(--bs-secondary) !important;
      }
    `;

    document.head.appendChild(style);
  }

  protected static _setSiteName(site_name: null | string): void {
    if (!site_name) {
      return;
    }

    config.siteName = site_name;
  }

  protected static _setBackgroundMain(background_url: null | string): void {
    if (!background_url) {
      return;
    }

    config.main.background.main = background_url;
  }

  protected static _setSiteLogo(
    logo_url: string | null,
    dark_logo_url: string | null
  ): void {
    if (logo_url) {
      config.main.logo.light = logo_url;
      config.loader.logo = logo_url;
    }
    if (dark_logo_url) {
      config.main.logo.dark = dark_logo_url;
    }
  }

  protected static _setSupportEmail(support_email: null | string): void {
    if (!support_email) {
      return;
    }
    config.main.support_email = support_email;
  }

  protected static _setSiteFavicon(favicon_url: string | null): void {
    if (!favicon_url) {
      return;
    }
    ThemeService.$favicon = favicon_url;

    const favicon = document.querySelector(
      'link[rel="icon"]'
    ) as HTMLLinkElement;
    if (favicon) {
      favicon.href = favicon_url;
    }
  }
}
